import { ScopeOfPracticeEnum } from '@umss/shared/utils';
import { BillingStatus } from '../payments.model';

export interface Timesheet {
  createdAt: string;
  updatedAt: string;
  id: string;
  contractorId: string;
  contractorName: string;
  facilityId: string;
  facilityName: string;
  weekStartDate: string;
  weekEndDate: string;
  totalHours: number;
  totalAmount: number;
  transactionFeeAmount: number;
  netTotalAmount: number;
  status: BillingStatus;
  statusDisplay: string;
  submittedAt: string;
  approvedAt: string;
  approvedByName: string;
  rejectionReason: string;
  entries: TimesheetEntry[];
}

export interface TimesheetWithEntry {
  createdAt: string;
  updatedAt: string;
  id: string;
  timesheetId: string;
  contractorId: string;
  contractorName: string;
  facilityId: string;
  facilityName: string;
  weekStartDate: string;
  weekEndDate: string;
  timesheetStatus: BillingStatus;
  timesheetStatusDisplay: string;
  submittedAt: string;
  approvedAt: string;
  approvedByName: string;
  entryId: string;
  shiftId: string;
  shiftDate: string;
  startTime: string;
  endTime: string;
  hoursWorked: number;
  hourlyRate: number;
  lineTotal: number;
  scopeOfPractice: ScopeOfPracticeEnum;
  supervisorName: string;
  breakDurationMinutes: number;
  contractorNotes: string;
  clockInNote?: string;
  clockOutNote?: string;
  timesheetNumber: number;
  timesheetNumberDisplay: string;
}

export interface TimesheetEntry {
  id: string;
  shiftId: string;
  shiftDate: string;
  hoursWorked: number;
  hourlyRate: number;
  lineTotal: number;
  facilityName: string;
  scopeOfPractice: string;
  startTime: string;
  endTime: string;
}
